export default "__VITE_ASSET__295f874d__"